window.onload=function(){
  $('.animate-btn-fill').hover(
              function() {
                  $(this).find(".btn-fill").css({
                        "transform":"translateY(0)"
                  })
              },
              function() {
                   $(this).find(".btn-fill").css({
                        "transform":"translate3d(0,-76%,0)"
                  })
              }
          )
}